
import React from 'react';
import { GameState } from '../types';

interface GridProps {
  gameState: GameState;
  onCellClick: (r: number, c: number) => void;
  lastMoveCorrect: boolean | null;
}

const SudokuGrid: React.FC<GridProps> = ({ gameState, onCellClick, lastMoveCorrect }) => {
  const highlightInfo = {
    row: gameState.selectedCell?.[0] ?? -1,
    col: gameState.selectedCell?.[1] ?? -1,
    val: gameState.selectedCell ? gameState.grid[gameState.selectedCell[0]][gameState.selectedCell[1]].value : null
  };

  return (
    <div className="grid grid-cols-9 gap-1 md:gap-1.5 bg-black/50 p-2 md:p-4 rounded-[1.5rem] md:rounded-[2.5rem] border-[4px] md:border-[10px] border-[#1a1a1a] shadow-[0_0_60px_rgba(0,0,0,0.8)]">
      {gameState.grid.map((row, r) => row.map((cell, c) => {
        const isSelected = gameState.selectedCell?.[0] === r && gameState.selectedCell?.[1] === c;
        const sameValueHighlight = highlightInfo.val !== null && cell.value === highlightInfo.val;
        const relatedHighlight = highlightInfo.row === r || highlightInfo.col === c || (Math.floor(r/3) === Math.floor(highlightInfo.row/3) && Math.floor(c/3) === Math.floor(highlightInfo.col/3));
        const subBox = (Math.floor(r / 3) + Math.floor(c / 3)) % 2 === 0;
        
        return (
          <div key={`${r}-${c}`} onClick={() => onCellClick(r, c)}
            className={`w-[min(8.5vw,9vh,64px)] h-[min(8.5vw,9vh,64px)] flex items-center justify-center text-xl md:text-3xl lg:text-4xl font-black cursor-pointer transition-all relative rounded-md
            ${subBox ? 'bg-[#0a0a0a]' : 'bg-[#121212]'}
            ${relatedHighlight && !isSelected ? 'bg-white/[0.03]' : ''}
            ${sameValueHighlight && !isSelected ? 'bg-blue-500/10' : ''}
            ${isSelected ? 'z-20 scale-105 md:scale-110 ring-2 md:ring-4 ring-[#ff0040] bg-[#1a1a1a] shadow-[0_0_30px_rgba(255,0,64,0.5)]' : 'border border-white/5'}
            ${cell.initial ? 'text-gray-700' : cell.valid ? 'text-blue-100' : 'text-red-600'}
            ${isSelected && lastMoveCorrect === true ? 'correct-pulse' : ''}`}>
            {cell.value || (cell.notes.length > 0 && (
              <div className="note-grid">
                {[1,2,3,4,5,6,7,8,9].map(n => <div key={n} className="note-digit text-[8px] md:text-[10px]">{cell.notes.includes(n) ? n : ''}</div>)}
              </div>
            ))}
            {cell.type !== 'NORMAL' && !cell.initial && !cell.value && <div className="absolute inset-0 flex items-center justify-center opacity-10 text-[6px] md:text-[8px] font-black uppercase tracking-widest">{cell.type}</div>}
          </div>
        );
      }))}
    </div>
  );
};

export default SudokuGrid;
